import React, { useState, useEffect, useContext, useMemo } from "react";
import URLstateContext from "./../../../provider/CommonContext";
import { Col, Container, Row } from 'react-bootstrap';
import Pagination from './../../CommonUI/Pagination/Pagination';
import { Modal } from "react-bootstrap";
import './Calender.css';
import { format, parseISO } from 'date-fns';
import { Vortex } from 'react-loader-spinner'

function Calender() {

    const [data, setData] = useState([]);
    const [dataCorp, setDataCorp] = useState([]);
    const handleShow = () => setShow(true);
    const [show, setShow] = useState(false);
    const [filteredNewsData, setFilteredNewsData] = useState([]);
    const handleClose = () => setShow(false);
    const [dataGroup, setDataGroup] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [groupValue, setGroupValue] = useState("day");
    const [type, settype] = useState('');
    const { BaseURL } = useContext(URLstateContext);
    const [loadingshow, setloadingshow] = useState(false);
    let getData, getDataGroup, eleBtn, eleBtnLoose, eleLi;
    let PageSize = 8;


  

    const today = new Date();
    const yyyy = today.getFullYear();
    let mm = today.getMonth() + 1;
    let dd = today.getDate();
    if (dd < 10) dd = '0' + dd;
    if (mm < 10) mm = '0' + mm;
    const formattedToday = yyyy + '-' + mm + '-' + dd;
    const firstDay = new Date(today.setDate(today.getDate() - today.getDay()));
    const yyyyW = firstDay.getFullYear();
    let mmW = firstDay.getMonth() + 1;
    let ddW = firstDay.getDate();
    if (ddW < 10) ddW = '0' + ddW;
    if (mmW < 10) mmW = '0' + mmW;
    const formattedFirstDay = yyyyW + '-' + mmW + '-' + ddW;
    const lastDay = new Date(today.setDate(today.getDate() - today.getDay() + 6));
    const yyyyWL = lastDay.getFullYear();
    let mmWL = lastDay.getMonth() + 1;
    let ddWL = lastDay.getDate();
    if (ddWL < 10) ddWL = '0' + ddWL;
    if (mmWL < 10) mmWL = '0' + mmWL;
    const formattedLastDay = yyyyWL + '-' + mmWL + '-' + ddWL;
    var date = new Date();
    var firstDayMon = new Date(date.getFullYear(), date.getMonth(), 1);
    const yyyyM = firstDayMon.getFullYear();
    let mmM = firstDayMon.getMonth() + 1;
    let ddM = firstDayMon.getDate();
    if (ddM < 10) ddM = '0' + ddM;
    if (mmM < 10) mmM = '0' + mmM;
    const formattedFirstMonth = yyyyM + '-' + mmM + '-' + ddM;
    var lastDayMon = new Date(date.getFullYear(), date.getMonth() + 1, 0);
    const yyyyML = lastDayMon.getFullYear();
    let mmML = lastDayMon.getMonth() + 1;
    let ddML = lastDayMon.getDate();
    if (ddML < 10) ddML = '0' + ddML;
    if (mmML < 10) mmML = '0' + mmML;
    const formattedLastMonth = yyyyML + '-' + mmML + '-' + ddML;

    const handleChange = (event) => {
        let corptypeID = event.currentTarget.getAttribute('data-id');
        if (corptypeID === "Dividend")
            settype('Dividend');
        else if (corptypeID === "Bonus")
            settype('Bonus');
        else if (corptypeID === "Split")
            settype('Split');
        else if (corptypeID === "BuyBack")
            settype('BuyBack');
        else if (corptypeID === "Rights")
            settype('Rights');
        else if (corptypeID === "AGM")
            settype('AGM');
        else if (corptypeID === "Board Meeting")
            settype('Board Meeting');
        else if (corptypeID === "EGM")
            settype('EGM');
        else if (corptypeID === "Book Closure")
            settype('Book Closure');
        else if (corptypeID === "Result")
            settype('Result');
        handleShow();
    }
    useEffect(() => {
        setloadingshow(true);
        window.scrollTo(0, 0)
        if (groupValue === "day") {
            const getUrlList = BaseURL + "Eventcal";
            fetch(`${getUrlList}/${groupValue}`)
                .then((response) => response.json())
                .then((data) => {
                    getData = data.data;
                    setData(getData);
                    setloadingshow(false);
                })
                .catch((error) => {
                });

            const getUrlNewe = BaseURL + "CorporateAction";
            fetch(`${getUrlNewe}/${type}/${formattedToday}/${formattedToday}/-/-`)
                .then((response) => response.json())
                .then((data) => {
                    getData = data.data;
                    setDataCorp(getData);
                    setloadingshow(false);
                })
                .catch((error) => {
                });
        } else if (groupValue === "week") {
            const getUrlNew = BaseURL + "Eventcal";
            fetch(`${getUrlNew}/${groupValue}`)
                .then((response) => response.json())
                .then((data) => {
                    getData = data.data;
                    setData(getData);
                    setloadingshow(false);
                })
                .catch((error) => {
                });

            const getUrlNewe = BaseURL + "CorporateAction";
            fetch(`${getUrlNewe}/${type}/${formattedFirstDay}/${formattedLastDay}/-/-`)
                .then((response) => response.json())
                .then((data) => {
                    getData = data.data;
                    setDataCorp(getData);
                    setloadingshow(false);
                })
                .catch((error) => {
                });
        } else {
            const getUrlNew = BaseURL + "Eventcal";
            fetch(`${getUrlNew}/month`)
                .then((response) => response.json())
                .then((data) => {
                    getData = data.data;
                    setData(getData);
                    setloadingshow(false);

                })
                .catch((error) => {
                });

            const getUrlNewe = BaseURL + "CorporateAction";
            fetch(`${getUrlNewe}/${type}/${formattedFirstMonth}/${formattedLastMonth}/-/-`)
                .then((response) => response.json())
                .then((data) => {
                    getData = data.data;
                    setDataCorp(getData);
                    setloadingshow(false);
                })
                .catch((error) => {
                });
        }

    }, [groupValue, type, formattedFirstMonth, formattedLastMonth, formattedFirstDay, formattedLastDay, formattedToday]);


    return (
        <>

            <div class="Calen-inner-common">
                <div className='Calen-header'>
                    <h3 class="cal-result-head">Event / Result Calendar</h3>
                </div>
                <div className="eventdowndiv">
                    <div className='calender-loser-toggle'>
                        <button id="day" value="day" className={(groupValue === "day") ? "active" : ''} onClick={(event) => { setGroupValue(event.target.value) }} >TODAY</button>
                        <button id="week" value="week" className={(groupValue === "week") ? "active" : ''} onClick={(event) => { setGroupValue(event.target.value) }}>WEEK</button>
                        <button id="month" value="month" className={(groupValue === "month") ? "active" : ''} onClick={(event) => { setGroupValue(event.target.value) }}>MONTH</button>

                    </div>
                </div>
                <div className='Calen-table table-responsive'>
                    {(() => {

                        if (groupValue === "day") {
                            return (
                                <>
                                    <div className="eventMainDiv">
                                        {data && data.map(
                                            ({ totalcount, corptype }) => (

                                                <div className={(corptype === "Dividend") ? "color1 cal-item" : (corptype === "Bonus") ? "color2 cal-item" : (corptype === "Split") ? "color3 cal-item" : (corptype === "BuyBack") ? "color4 cal-item" : (corptype === "Rights") ? "color5 cal-item" : (corptype === "AGM") ? "color6 cal-item" : (corptype === "Board Meeting") ? "color7 cal-item" : (corptype === "EGM") ? "color8 cal-item" : (corptype === "Book Closure") ? "color9 cal-item" : (corptype === "Result") ? "color10 cal-item" : ''} data-id={corptype} onClick={handleChange}>
                                                    <div class="cal-num">{totalcount}</div>
                                                    <p className="CalFont">{corptype}</p>
                                                </div>
                                            ))}
                                    </div>
                                </>)
                        } else if (groupValue === "week") {
                            return (
                                <>
                                    <div className="eventMainDiv">
                                        {data && data.map(
                                            ({ totalcount, corptype }) => (

                                                <div className={(corptype === "Dividend") ? "color1 cal-item" : (corptype === "Bonus") ? "color2 cal-item" : (corptype === "Split") ? "color3 cal-item" : (corptype === "BuyBack") ? "color4 cal-item" : (corptype === "Rights") ? "color5 cal-item" : (corptype === "AGM") ? "color6 cal-item" : (corptype === "Board Meeting") ? "color7 cal-item" : (corptype === "EGM") ? "color8 cal-item" : (corptype === "Book Closure") ? "color9 cal-item" : (corptype === "Result") ? "color10 cal-item" : ''} data-id={corptype} onClick={handleChange}>
                                                    <div class="cal-num">{totalcount}</div>
                                                    <p className="CalFont">{corptype}</p>
                                                </div>

                                            ))}
                                    </div>
                                </>)
                        } else {
                            return (
                                <>
                                    <div className="eventMainDiv">
                                        {data && data.map(
                                            ({ totalcount, corptype }) => (

                                                <div className={(corptype === "Dividend") ? "color1 cal-item" : (corptype === "Bonus") ? "color2 cal-item" : (corptype === "Split") ? "color3 cal-item" : (corptype === "BuyBack") ? "color4 cal-item" : (corptype === "Rights") ? "color5 cal-item" : (corptype === "AGM") ? "color6 cal-item" : (corptype === "Board Meeting") ? "color7 cal-item" : (corptype === "EGM") ? "color8 cal-item" : (corptype === "Book Closure") ? "color9 cal-item" : (corptype === "Result") ? "color10 cal-item" : ''} data-id={corptype} onClick={handleChange}>
                                                    <div class="cal-num">{totalcount}</div>
                                                    <p className="CalFont">{corptype}</p>
                                                </div>

                                            ))}
                                    </div>
                                </>)
                        }
                    })()}

                </div>

                <Modal show={show} className="modal company-snap-modalOpt">
                    <Modal.Body id="modal_infoComp">

                        <div className="btnDiv">
                            <div className="btnclFandO" onClick={handleClose} > X </div>
                        </div>

                        <Container>
                            <Row>
                                {(dataCorp != null) ?
                                    <Col sm={12}>


                                        {(() => {

                                            if (type === "Dividend") {
                                                return (
                                                    <>
                                                        <section className='calender-loser-sc'>
                                                            <div className='calender-header'>
                                                                <h2><span>Dividend</span></h2>
                                                            </div>

                                                            <div className='calender-table table-responsive'>
                                                                <table className='table'>

                                                                    <thead>
                                                                        <tr>
                                                                            <th className="text-left">Company Name</th>
                                                                            <th className="text-center">Div Type</th>
                                                                            <th className="text-right">Div %</th>
                                                                            <th className="text-right">Div Amount</th>
                                                                            <th className="text-center">Announcement Date</th>
                                                                            <th className="text-center">Record Date</th>
                                                                            <th className="text-center">Ex-Div Date</th>

                                                                        </tr>
                                                                    </thead>
                                                                    {dataCorp &&
                                                                        dataCorp.map(({ co_name, DividendType, DivPer, AnnouncementDate, RecordDate, DivDate, DivAmount }) => (
                                                                            <tbody>
                                                                                <tr>
                                                                                    <td className="text-left">{co_name}</td>
                                                                                    <td className="text-center">{DividendType}</td>
                                                                                    <td className="text-right">{DivPer}</td>
                                                                                    <td className="text-right">{DivAmount}</td>
                                                                                    <td className="text-center">{(AnnouncementDate != null) ? (format(parseISO(AnnouncementDate), 'dd-MMM-yyyy')) : ''}</td>
                                                                                    <td className="text-center">{(RecordDate != null) ? (format(parseISO(RecordDate), 'dd-MMM-yyyy')) : ''}</td>
                                                                                    <td className="text-center">{(DivDate != null) ? (format(parseISO(DivDate), 'dd-MMM-yyyy')) : ''}</td>
                                                                                </tr>

                                                                            </tbody>
                                                                        ))}
                                                                </table >
                                                                {loadingshow ? <div className="textcentervertex">
                                                                    <Vortex
                                                                        visible={true}
                                                                        height="80"
                                                                        width="80"
                                                                        ariaLabel="vortex-loading"
                                                                        wrapperStyle={{}}
                                                                        wrapperClass="vortex-wrapper"
                                                                        colors={['#0473ea', '#0473ea', '#0473ea', '#39d800', '#39d800', '#39d800']}
                                                                    />
                                                                    <div className="model_popup">Please Wait...</div>
                                                                </div> : ""
                                                                }
                                                            </div>

                                                        </section >
                                                    </>)
                                            } else if (type === "Bonus") {
                                                return (
                                                    <>
                                                        <section className='calender-loser-sc'>
                                                            <div className='calender-header'>
                                                                <h2><span>Bonus</span></h2>
                                                            </div>

                                                            <div className='calender-table table-responsive'>
                                                                <table className='table'>

                                                                    <thead>
                                                                        <tr>
                                                                            <th className='text-left'>Company Name</th>
                                                                            <th className='text-center'>Ratio</th>
                                                                            <th className='text-center'>Record Date</th>
                                                                            <th className='text-center'>Ex Date</th>
                                                                        </tr>
                                                                    </thead>
                                                                    {dataCorp &&
                                                                        dataCorp.map(({ BonusDate, RecordDate, BonusRatio, co_name }) => (
                                                                            <tbody>
                                                                                <tr>
                                                                                    <td className="text-left">{co_name}</td>
                                                                                    <td className="text-center">{BonusRatio}</td>
                                                                                    <td className="text-center"> {(RecordDate != null) ? (format(parseISO(RecordDate), 'dd-MMM-yyyy')) : 0}</td>
                                                                                    <td className="text-center"> {(BonusDate != null) ? (format(parseISO(BonusDate), 'dd-MMM-yyyy')) : 0}</td>
                                                                                </tr>

                                                                            </tbody>
                                                                        ))}
                                                                </table >
                                                                {loadingshow ? <div className="textcentervertex">
                                                                    <Vortex
                                                                        visible={true}
                                                                        height="80"
                                                                        width="80"
                                                                        ariaLabel="vortex-loading"
                                                                        wrapperStyle={{}}
                                                                        wrapperClass="vortex-wrapper"
                                                                        colors={['#0473ea', '#0473ea', '#0473ea', '#39d800', '#39d800', '#39d800']}
                                                                    />
                                                                    <div className="model_popup">Please Wait...</div>
                                                                </div> : ""
                                                                }
                                                            </div>


                                                        </section >
                                                    </>)
                                            } else if (type === "Split") {
                                                return (
                                                    <>
                                                        <section className='calender-loser-sc'>
                                                            <div className='calender-header'>
                                                                <h2><span>Split</span></h2>
                                                            </div>

                                                            <div className='calender-table table-responsive'>
                                                                <table className='table'>

                                                                    <thead>
                                                                        <tr>
                                                                            <th className='text-left'>Company Name</th>
                                                                            <th className='text-center'>Announcement Date</th>
                                                                            <th className='text-center'>Split Date</th>
                                                                            <th className='text-right'>FV Before(&#8377;)</th>
                                                                            <th className='text-right'>FV After(&#8377;)</th>


                                                                        </tr>
                                                                    </thead>
                                                                    {dataCorp &&
                                                                        dataCorp.map(({ co_name, AnnouncementDate, SplitDate, FVBefore, FVAfter }) => (
                                                                            <tbody>
                                                                                <tr>
                                                                                    <td className="text-left">{co_name}</td>
                                                                                    <td className="text-center">{(AnnouncementDate != null) ? format(parseISO(AnnouncementDate), 'dd-MMM-yyyy') : ''}</td>
                                                                                    <td className="text-center">{(SplitDate != null) ? format(parseISO(SplitDate), 'dd-MMM-yyyy') : ''}</td>
                                                                                    <td className="text-right"> {FVBefore}</td>
                                                                                    <td className="text-right"> {FVAfter}</td>
                                                                                </tr>

                                                                            </tbody>
                                                                        ))}
                                                                </table >
                                                                {loadingshow ? <div className="textcentervertex">
                                                                    <Vortex
                                                                        visible={true}
                                                                        height="80"
                                                                        width="80"
                                                                        ariaLabel="vortex-loading"
                                                                        wrapperStyle={{}}
                                                                        wrapperClass="vortex-wrapper"
                                                                        colors={['#0473ea', '#0473ea', '#0473ea', '#39d800', '#39d800', '#39d800']}
                                                                    />
                                                                    <div className="model_popup">Please Wait...</div>
                                                                </div> : ""
                                                                }
                                                            </div>

                                                        </section >
                                                    </>)

                                            } else if (type === "BuyBack") {
                                                return (
                                                    <>
                                                        <section className='calender-loser-sc'>
                                                            <div className='calender-header'>
                                                                <h2><span>BuyBack</span></h2>
                                                            </div>

                                                            <div className='calender-table table-responsive'>
                                                                <table className='table'>

                                                                    <thead>
                                                                        <tr>
                                                                            <th className='text-left'>Company Name</th>
                                                                            <th className='text-right'>Buyback Price </th>
                                                                            <th className='text-center'>Buyback Type</th>
                                                                            <th className='text-center'>Announcement Date</th>
                                                                            <th className='text-center'>Open Date</th>
                                                                            <th className='text-center'>Close Date</th>
                                                                        </tr>
                                                                    </thead>
                                                                    {dataCorp &&
                                                                        dataCorp.map(({ co_name, maxbuybackprice, offertype, BBFromdate, BBToDate, AnnouncementDate }) => (
                                                                            <tbody>
                                                                                <tr>
                                                                                    <td className="text-left">{co_name}</td>
                                                                                    <td className="text-right">{maxbuybackprice}</td>
                                                                                    <td className="text-center">{offertype}</td>
                                                                                    <td className="text-center">{(AnnouncementDate != null) ? (format(parseISO(AnnouncementDate), 'dd-MMM-yyyy')) : ''}</td>
                                                                                    {/* <th className="textcenter">{format(parseISO(recorddate), 'dd-MMM-yyyy')}</th> */}
                                                                                    <td className="text-center">{BBFromdate != null ? format(parseISO(BBFromdate), 'dd-MMM-yyyy') : ""}</td>
                                                                                    <td className="text-center">{BBToDate != null ? format(parseISO(BBToDate), 'dd-MMM-yyyy') : ""}</td>

                                                                                </tr>

                                                                            </tbody>
                                                                        ))}
                                                                </table >
                                                                {loadingshow ? <div className="textcentervertex">
                                                                    <Vortex
                                                                        visible={true}
                                                                        height="80"
                                                                        width="80"
                                                                        ariaLabel="vortex-loading"
                                                                        wrapperStyle={{}}
                                                                        wrapperClass="vortex-wrapper"
                                                                        colors={['#0473ea', '#0473ea', '#0473ea', '#39d800', '#39d800', '#39d800']}
                                                                    />
                                                                    <div className="model_popup">Please Wait...</div>
                                                                </div> : ""
                                                                }
                                                            </div>

                                                        </section >
                                                    </>)

                                            } else if (type === "Rights") {
                                                return (
                                                    <>
                                                        <section className='calender-loser-sc'>
                                                            <div className='calender-header'>
                                                                <h2><span>Rights</span></h2>
                                                            </div>

                                                            <div className='calender-table table-responsive'>
                                                                <table className='table'>

                                                                    <thead>
                                                                        <tr>
                                                                            <th className='text-left'>Company Name</th>
                                                                            <th className='text-right'>Premium (&#8377;)</th>
                                                                            <th className='text-center'>Ratio</th>
                                                                            <th className='text-center'>Record Date</th>
                                                                            <th className='text-center'>Ex Date</th>
                                                                        </tr>
                                                                    </thead>
                                                                    {dataCorp &&
                                                                        dataCorp.map(({ co_name, premium, RightsRatio, recorddate, RightDate }) => (
                                                                            <tbody>
                                                                                <tr>
                                                                                    <td className="text-left">{co_name}</td>
                                                                                    <td className="text-right">{premium}</td>
                                                                                    <td className="text-center">{RightsRatio}</td>
                                                                                    <td className="text-center">{(recorddate != null) ? (format(parseISO(recorddate), 'dd-MMM-yyyy')) : ''}</td>
                                                                                    <td className="text-center">{(RightDate != null) ? (format(parseISO(RightDate), 'dd-MMM-yyyy')) : ''}</td>
                                                                                </tr>

                                                                            </tbody>
                                                                        ))}
                                                                </table >
                                                                {loadingshow ? <div className="textcentervertex">
                                                                    <Vortex
                                                                        visible={true}
                                                                        height="80"
                                                                        width="80"
                                                                        ariaLabel="vortex-loading"
                                                                        wrapperStyle={{}}
                                                                        wrapperClass="vortex-wrapper"
                                                                        colors={['#0473ea', '#0473ea', '#0473ea', '#39d800', '#39d800', '#39d800']}
                                                                    />
                                                                    <div className="model_popup">Please Wait...</div>
                                                                </div> : ""
                                                                }
                                                            </div>

                                                        </section >
                                                    </>)

                                            } else if (type === "AGM") {
                                                return (
                                                    <>
                                                        <section className='calender-loser-sc'>
                                                            <div className='calender-header'>
                                                                <h2><span>AGM</span></h2>
                                                            </div>

                                                            <div className='calender-table table-responsive'>
                                                                <table className='table'>

                                                                    <thead>
                                                                        <tr>
                                                                            <th className='text-left'>Company Name</th>
                                                                            <th className='text-center'>Announcement Date</th>
                                                                            <th className='text-center'>AGM Date</th>

                                                                        </tr>
                                                                    </thead>
                                                                    {dataCorp &&
                                                                        dataCorp.map(({ co_name, AnnouncementDate, GMdate }) => (
                                                                            <tbody>
                                                                                <tr>
                                                                                    <td className="text-left">{co_name}</td>
                                                                                    <td className="text-center">{(AnnouncementDate != null) ? format(parseISO(AnnouncementDate), 'dd-MMM-yyyy') : ''}</td>
                                                                                    <td className="text-center">{(GMdate != null) ? format(parseISO(GMdate), 'dd-MMM-yyyy') : ''}</td>

                                                                                </tr>

                                                                            </tbody>
                                                                        ))}
                                                                </table >
                                                                {loadingshow ? <div className="textcentervertex">
                                                                    <Vortex
                                                                        visible={true}
                                                                        height="80"
                                                                        width="80"
                                                                        ariaLabel="vortex-loading"
                                                                        wrapperStyle={{}}
                                                                        wrapperClass="vortex-wrapper"
                                                                        colors={['#0473ea', '#0473ea', '#0473ea', '#39d800', '#39d800', '#39d800']}
                                                                    />
                                                                    <div className="model_popup">Please Wait...</div>
                                                                </div> : ""
                                                                }
                                                            </div>

                                                        </section >
                                                    </>)

                                            } else if (type === "Board Meeting") {
                                                return (
                                                    <>
                                                        <section className='calender-loser-sc'>
                                                            <div className='calender-header'>
                                                                <h2><span>Board Meeting</span></h2>
                                                            </div>

                                                            <div className='calender-table table-responsive'>
                                                                <table className='table'>

                                                                    <thead>
                                                                        <tr>
                                                                            <th className='text-left'>Company Name</th>
                                                                            <th className='text-center'>Announcement Date</th>
                                                                            <th className='text-center'>Board Meeting Date</th>

                                                                        </tr>
                                                                    </thead>
                                                                    {dataCorp &&
                                                                        dataCorp.map(({ co_name, AnnouncementDate, BMdate }) => (
                                                                            <tbody>
                                                                                <tr>
                                                                                    <td className="text-left">{co_name}</td>
                                                                                    <td className="text-center">{(AnnouncementDate != null) ? format(parseISO(AnnouncementDate), 'dd-MMM-yyyy') : ''}</td>
                                                                                    <td className="text-center">{(BMdate != null) ? format(parseISO(BMdate), 'dd-MMM-yyyy') : ''}</td>

                                                                                </tr>

                                                                            </tbody>
                                                                        ))}
                                                                </table >
                                                                {loadingshow ? <div className="textcentervertex">
                                                                    <Vortex
                                                                        visible={true}
                                                                        height="80"
                                                                        width="80"
                                                                        ariaLabel="vortex-loading"
                                                                        wrapperStyle={{}}
                                                                        wrapperClass="vortex-wrapper"
                                                                        colors={['#0473ea', '#0473ea', '#0473ea', '#39d800', '#39d800', '#39d800']}
                                                                    />
                                                                    <div className="model_popup">Please Wait...</div>
                                                                </div> : ""
                                                                }
                                                            </div>

                                                        </section >
                                                    </>)

                                            } else if (type === "EGM") {
                                                return (
                                                    <>
                                                        <section className='calender-loser-sc'>
                                                            <div className='calender-header'>
                                                                <h2><span>EGM</span></h2>
                                                            </div>

                                                            <div className='calender-table table-responsive'>
                                                                <table className='table'>

                                                                    <thead>
                                                                        <tr>
                                                                            <th className='text-left'>Company Name</th>
                                                                            <th className='text-center'>Announcement Date</th>
                                                                            <th className='text-center'>EGM Date</th>

                                                                        </tr>
                                                                    </thead>
                                                                    {dataCorp &&
                                                                        dataCorp.map(({ co_name, AnnouncementDate, GMdate }) => (
                                                                            <tbody>
                                                                                <tr>
                                                                                    <td className="text-left">{co_name}</td>
                                                                                    <td className="text-center">{(AnnouncementDate != null) ? format(parseISO(AnnouncementDate), 'dd-MMM-yyyy') : ''}</td>
                                                                                    <td className="text-center">{(GMdate != null) ? format(parseISO(GMdate), 'dd-MMM-yyyy') : ''}</td>

                                                                                </tr>

                                                                            </tbody>
                                                                        ))}
                                                                </table >
                                                                {loadingshow ? <div className="textcentervertex">
                                                                    <Vortex
                                                                        visible={true}
                                                                        height="80"
                                                                        width="80"
                                                                        ariaLabel="vortex-loading"
                                                                        wrapperStyle={{}}
                                                                        wrapperClass="vortex-wrapper"
                                                                        colors={['#0473ea', '#0473ea', '#0473ea', '#39d800', '#39d800', '#39d800']}
                                                                    />
                                                                    <div className="model_popup">Please Wait...</div>
                                                                </div> : ""
                                                                }
                                                            </div>

                                                        </section >
                                                    </>)

                                            } else if (type === "Book Closure") {
                                                return (
                                                    <>
                                                        <section className='calender-loser-sc'>
                                                            <div className='calender-header'>
                                                                <h2><span>Book Closure</span></h2>
                                                            </div>

                                                            <div className='calender-table table-responsive'>
                                                                <table className='table'>

                                                                    <thead>
                                                                        <tr>
                                                                            <th className="text-left">Company Name</th>
                                                                            <th className="text-center">Announcement Date</th>
                                                                            <th className="text-center">Book Closure (From Date)</th>
                                                                            <th className="text-center">Book Closure (To Date)</th>

                                                                        </tr>
                                                                    </thead>
                                                                    {dataCorp &&
                                                                        dataCorp.map(({ AnnouncementDate, BCFromdate, BCToDate, Co_name }) => (
                                                                            <tbody>
                                                                                <tr>
                                                                                    <td className="text-left">{Co_name}</td>
                                                                                    <td className="text-center">{(AnnouncementDate != null) ? (format(parseISO(AnnouncementDate), 'dd-MMM-yyyy')) : ''}</td>
                                                                                    <td className="text-center">{(BCFromdate != null) ? (format(parseISO(BCFromdate), 'dd-MMM-yyyy')) : ''}</td>
                                                                                    <td className="text-center">{(BCToDate != null) ? (format(parseISO(BCToDate), 'dd-MMM-yyyy')) : 0}</td>
                                                                                </tr>

                                                                            </tbody>
                                                                        ))}
                                                                </table >
                                                                {loadingshow ? <div className="textcentervertex">
                                                                    <Vortex
                                                                        visible={true}
                                                                        height="80"
                                                                        width="80"
                                                                        ariaLabel="vortex-loading"
                                                                        wrapperStyle={{}}
                                                                        wrapperClass="vortex-wrapper"
                                                                        colors={['#0473ea', '#0473ea', '#0473ea', '#39d800', '#39d800', '#39d800']}
                                                                    />
                                                                    <div className="model_popup">Please Wait...</div>
                                                                </div> : ""
                                                                }
                                                            </div>
                                                        </section >
                                                    </>)

                                            } else if (type === "Result") {
                                                return (
                                                    <>
                                                        <section className='calender-loser-sc'>
                                                            <div className='calender-header'>
                                                                <h2><span>Result</span></h2>
                                                            </div>

                                                            <div className='calender-table table-responsive'>
                                                                <table className='table'>

                                                                    <thead>
                                                                        <tr>
                                                                            <th className='text-left'>Company Name</th>
                                                                            <th className='text-center'>Announcement Date</th>
                                                                            <th className='text-center'>Result Date</th>

                                                                        </tr>
                                                                    </thead>
                                                                    {dataCorp &&
                                                                        dataCorp.map(({ co_name, AnnouncementDate, ResultDate }) => (
                                                                            <tbody>
                                                                                <tr>
                                                                                    <td className="text-left">{co_name}</td>
                                                                                    <td className="text-center">{(AnnouncementDate != null) ? format(parseISO(AnnouncementDate), 'dd-MMM-yyyy') : ''}</td>
                                                                                    <td className="text-center">{(ResultDate != null) ? format(parseISO(ResultDate), 'dd-MMM-yyyy') : ''}</td>

                                                                                </tr>

                                                                            </tbody>
                                                                        ))}
                                                                </table >
                                                                {loadingshow ? <div className="textcentervertex">
                                                                    <Vortex
                                                                        visible={true}
                                                                        height="80"
                                                                        width="80"
                                                                        ariaLabel="vortex-loading"
                                                                        wrapperStyle={{}}
                                                                        wrapperClass="vortex-wrapper"
                                                                        colors={['#0473ea', '#0473ea', '#0473ea', '#39d800', '#39d800', '#39d800']}
                                                                    />
                                                                    <div className="model_popup">Please Wait...</div>
                                                                </div> : ""
                                                                }
                                                            </div>
                                                        </section >
                                                    </>)

                                            }
                                        })()}


                                    </Col>
                                    : <h3 className="errorMsg">No Data Found</h3>}
                            </Row>
                        </Container>

                    </Modal.Body>
                </Modal>

            </div>



        </>

    );
}

export default Calender;